let form : HTMLFormElement;

function init() {
  form = document.querySelector<HTMLFormElement>('#contact--form, #request--form');
  form && form.addEventListener('submit', submit);
  
  const thanksButton = document.querySelector<HTMLButtonElement>('#contact--thanksButton');
  thanksButton && thanksButton.addEventListener('click', () => toggleSubmitted(false));
}

async function submit(e) {
  e.preventDefault();
  
  const formData = new FormData(form);
  const scriptName = (form.id === 'contact--form') ? 'submit_contact.php' : 'submit_quote.php';

  await fetch(`/wp-content/themes/prolocker/${ scriptName }`, {
    method: 'POST',
    mode: 'no-cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer',
    body: formData,
  });
  
  toggleSubmitted(true);
}

function toggleSubmitted(isSubmitted: boolean) {
  form.closest('.contactPage').classList.toggle('contactPage--submitted', isSubmitted);
}
  
export default { init };